export default "__VITE_ASSET__e8e105a9__"